module.exports = __webpack_public_path__ + "c64400754ae1c54969b26fdc9a254ac3.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/selection-control.png
// module id = 2410
// module chunks = 0